export default __webpack_public_path__ + "static/media/account-settings.5c6aeba6.svg";